// extracted by mini-css-extract-plugin
export default {"cardHeader":"HistoryListTable_cardHeader__TC31m","dateBadge":"HistoryListTable_dateBadge__HL1V7","title":"HistoryListTable_title__Vb0a2"};